import { useState } from 'react';

const useMultiplayerState = () => {
  const [gameMode, setGameMode] = useState('menu'); // menu, quickplay, lobby
  const [lobbyCode, setLobbyCode] = useState('');
  const [playerName, setPlayerName] = useState('');
  const [players, setPlayers] = useState([]);
  const [isHost, setIsHost] = useState(false);
  const [playerToken, setPlayerToken] = useState('');

  const resetMultiplayerState = () => {
    setGameMode('menu');
    setLobbyCode('');
    setPlayerName('');
    setPlayers([]);
    setIsHost(false);
    setPlayerToken('');
  };

  return {
    // State
    gameMode,
    setGameMode,
    lobbyCode,
    setLobbyCode,
    playerName,
    setPlayerName,
    players,
    setPlayers,
    isHost,
    setIsHost,
    playerToken,
    setPlayerToken,
    
    // Actions
    resetMultiplayerState
  };
};

export default useMultiplayerState;
